import React from "react"
import styled from "styled-components"
import media from "styled-media-query"

const StyledH3 = styled.h3`
  color: #0145a2;
  font-size: 19px;
  letter-spacing: -1px;
  margin: 0;
  ${media.greaterThan("small")`
    font-size: 22px;
  `}
`
const StyledSpan = styled.span`
  border-bottom: solid 1px #0247aa;
  display: inline-block;
  line-height: 32px;
  ${media.greaterThan("small")`
    line-height: 40px;
  `}
`
const Comment = styled.p`
  height: 14em;
  line-height: 1.89em;
  ${media.greaterThan("small")`
    line-height: 2em;
    margin: 16px 0 24px 0;
  `}
`

const RComment = props => {
  const hComment = props.hComment
  const comment = props.comment
  return (
    <>
      <StyledH3>
        <StyledSpan>{hComment.substr(0, 1)}</StyledSpan>
        {hComment.substr(1)}
      </StyledH3>
      <Comment>{comment}</Comment>
    </>
  )
}
export default RComment
